import {
	CategoryKeys,
	type QuestionIDType,
	QuestionsKeys,
} from 'help/types/types'

import { OrderStatus } from '../../types/purchases.types'

export const purchaseStatusInfo: Record<
	OrderStatus,
	{
		title: string
		showAddress: boolean
		status?: string
		questions: QuestionIDType[]
	}
> = {
	[OrderStatus.created]: {
		title: 'profile.lastPurchase.created.title',
		showAddress: true,
		questions: [
			{
				categoryKey: CategoryKeys.delivery,
				questionKey: QuestionsKeys.changeAddress,
			},
			{
				categoryKey: CategoryKeys.delivery,
				questionKey: QuestionsKeys.cancelOrder,
			},
			{
				categoryKey: CategoryKeys.productInfo,
				questionKey: QuestionsKeys.garmentCare,
			},
		],
	},
	[OrderStatus.in_preparation]: {
		title: 'profile.lastPurchase.preparation.title',
		showAddress: true,
		questions: [
			{
				categoryKey: CategoryKeys.delivery,
				questionKey: QuestionsKeys.orderStatus,
			},
			{
				categoryKey: CategoryKeys.delivery,
				questionKey: QuestionsKeys.changeAddress,
			},
			{
				categoryKey: CategoryKeys.delivery,
				questionKey: QuestionsKeys.cancelOrder,
			},
		],
	},
	[OrderStatus.ready]: {
		title: 'profile.lastPurchase.ready.title',
		showAddress: true,
		questions: [
			{
				categoryKey: CategoryKeys.delivery,
				questionKey: QuestionsKeys.changeAddress,
			},
			{
				categoryKey: CategoryKeys.delivery,
				questionKey: QuestionsKeys.cancelOrder,
			},
			{
				categoryKey: CategoryKeys.productInfo,
				questionKey: QuestionsKeys.garmentCare,
			},
		],
	},
	[OrderStatus.shipped]: {
		title: 'profile.lastPurchase.shipped.title',
		showAddress: true,
		questions: [
			{
				categoryKey: CategoryKeys.delivery,
				questionKey: QuestionsKeys.orderStatus,
			},
			{
				categoryKey: CategoryKeys.delivery,
				questionKey: QuestionsKeys.changeAddress,
			},
			{
				categoryKey: CategoryKeys.delivery,
				questionKey: QuestionsKeys.cancelOrder,
			},
		],
	},
	[OrderStatus.cancelled]: {
		title: 'profile.lastPurchase.cancelled.title',
		showAddress: false,
		status: 'profile.lastPurchase.cancelled.alert',
		questions: [
			{
				categoryKey: CategoryKeys.returns,
				questionKey: QuestionsKeys.returnsStatus,
			},
			{ categoryKey: CategoryKeys.returns, questionKey: QuestionsKeys.refunds },
			{
				categoryKey: CategoryKeys.loyalty,
				questionKey: QuestionsKeys.checkLikes,
			},
		],
	},
	[OrderStatus.rejected]: {
		title: 'profile.lastPurchase.rejected.title',
		showAddress: false,
		questions: [
			{ categoryKey: CategoryKeys.returns, questionKey: QuestionsKeys.refunds },
			{
				categoryKey: CategoryKeys.loyalty,
				questionKey: QuestionsKeys.checkLikes,
			},
		],
	},
	[OrderStatus.on_delivery]: {
		title: 'profile.lastPurchase.delivery.title',
		showAddress: true,
		questions: [
			{
				categoryKey: CategoryKeys.delivery,
				questionKey: QuestionsKeys.orderStatus,
			},
			{
				categoryKey: CategoryKeys.delivery,
				questionKey: QuestionsKeys.changeAddress,
			},
			{
				categoryKey: CategoryKeys.delivery,
				questionKey: QuestionsKeys.cancelOrder,
			},
		],
	},
	[OrderStatus.denied]: {
		title: 'profile.lastPurchase.denied.title',
		showAddress: false,
		status: 'profile.lastPurchase.denied.alert',
		questions: [
			{ categoryKey: CategoryKeys.returns, questionKey: QuestionsKeys.refunds },
			{
				categoryKey: CategoryKeys.loyalty,
				questionKey: QuestionsKeys.checkLikes,
			},
		],
	},
	[OrderStatus.in_store]: {
		title: 'profile.lastPurchase.store.title',
		showAddress: true,
		questions: [
			{
				categoryKey: CategoryKeys.productInfo,
				questionKey: QuestionsKeys.garmentCare,
			},
		],
	},
	[OrderStatus.in_droppoint]: {
		title: 'profile.lastPurchase.droppoint.title',
		showAddress: true,
		questions: [
			{
				categoryKey: CategoryKeys.productInfo,
				questionKey: QuestionsKeys.garmentCare,
			},
		],
	},
	[OrderStatus.on_international_transit]: {
		title: 'profile.lastPurchase.internationalTransit.title',
		showAddress: true,
		questions: [
			{
				categoryKey: CategoryKeys.delivery,
				questionKey: QuestionsKeys.orderStatus,
			},
			{
				categoryKey: CategoryKeys.delivery,
				questionKey: QuestionsKeys.changeAddress,
			},
			{
				categoryKey: CategoryKeys.delivery,
				questionKey: QuestionsKeys.cancelOrder,
			},
		],
	},
	[OrderStatus.annulled]: {
		title: 'profile.lastPurchase.totalStock.title',
		showAddress: false,
		status: 'profile.lastPurchase.totalStock.alert',
		questions: [
			{
				categoryKey: CategoryKeys.delivery,
				questionKey: QuestionsKeys.orderIncomplete,
			},
			{ categoryKey: CategoryKeys.returns, questionKey: QuestionsKeys.refunds },
			{
				categoryKey: CategoryKeys.loyalty,
				questionKey: QuestionsKeys.checkLikes,
			},
		],
	},
	[OrderStatus.cancellation_in_progress]: {
		title: 'profile.lastPurchase.cancelledInProgress.title',
		showAddress: false,
		status: 'profile.lastPurchase.cancelledInProgress.alert',
		questions: [
			{
				categoryKey: CategoryKeys.delivery,
				questionKey: QuestionsKeys.cancelOrder,
			},
			{ categoryKey: CategoryKeys.returns, questionKey: QuestionsKeys.refunds },
			{
				categoryKey: CategoryKeys.loyalty,
				questionKey: QuestionsKeys.checkLikes,
			},
		],
	},
}
